/** @jsx jsx */
import { Box } from "@eworkit/iris";
import { FC } from "react";
import { jsx } from "theme-ui";

import { AttachmentLike } from "@/data/attachments";

interface PublicProfileNewsCoverImageProps {
  image: AttachmentLike;
}

export const PublicProfileNewsCoverImage: FC<PublicProfileNewsCoverImageProps> = ({ image }) => {
  if (!image.publicUrl) {
    return null;
  }
  return (
    <Box>
      <img
        src={image.publicUrl}
        sx={{
          width: "100%",
          maxHeight: "100%",
        }}
      />
    </Box>
  );
};
